module.exports = __webpack_public_path__ + "static/img/1a (3).4dfb11b1.png";